import { DadosValorTerreno, SwitchesValorTerreno } from '../types/laudo-wizard.types';
import { AMOSTRAS_PADRONIZADAS } from './amostrasPadronizadas';

export const dadosValorTerrenoMock: DadosValorTerreno[] = AMOSTRAS_PADRONIZADAS
  .map((amostra) => ({
    amostra: amostra.identificacao,
    tipoImovel: amostra.tipoImovel,
    areaTerreno: Number(amostra.areaTerreno) || 0,
    padrao: amostra.padrao || 'Médio',
    topografia: amostra.topografia || 'Terreno Plano',
    valorTotalAmostra: Number(amostra.valorTotal) || 0,
    valorTerreno: 0,
    valorUnitario: 0,

    indiceFiscal: 1.0,
    fatorOferta: 1.0,
    fatorTopografia: amostra.topografia === 'Terreno Plano' ? 1.0 : 0.97,
    fatorArea: 1.0,
    fatorTestada: 1.0,
    fatorVegetacao: 1.0,
    fatorExtraI: 1.0,
    fatorExtraII: 1.0,
    fatorExtraIII: 1.0,

    fat: 0,
    valorUnitarioFinal: 0,
  }));

export const switchesTerrenoMock: SwitchesValorTerreno = {
  area: true,
  testada: true,
  vegetacao: false,
  fatorExtraI: false,
  fatorExtraII: false,
  fatorExtraIII: false,
};

